import api from '@/services/api.service';

function unwrap<T>(res: unknown): T {
  const body = (res as { data?: unknown })?.data ?? res;
  return (body as { data?: T })?.data ?? (body as T);
}

export interface AssetAccountingDefaultsDto {
  id?: string;
  company_id: string;
  asset_cost_account_id?: string | null;
  inventory_clearing_account_id?: string | null;
  accumulated_depreciation_account_id?: string | null;
  depreciation_expense_account_id?: string | null;
  disposal_proceeds_account_id?: string | null;
  disposal_gain_account_id?: string | null;
  disposal_loss_account_id?: string | null;
}

const assetAccountingDefaultsService = {
  async get(): Promise<AssetAccountingDefaultsDto> {
    const res = await api.get('/assets/accounting-defaults');
    return unwrap(res);
  },
  async save(body: Partial<AssetAccountingDefaultsDto>): Promise<AssetAccountingDefaultsDto> {
    const res = await api.put('/assets/accounting-defaults', body);
    return unwrap(res);
  },
};

export default assetAccountingDefaultsService;
